import store from 'store/storeConfig';

export const getAvailableCareProgramsByType = (programs: ICareProgram[]) => {
  return programs.reduce((programsByType: any, program) => {
    return {
      ...programsByType,
      [program.type]: [...(programsByType[program.type] || []), program]
    };
  }, {});
};

export const buildProgramOptionsByType = (programsByType: any) => {
  const { intl } = store.getState();
  return Object.keys(programsByType).reduce((optionsByType: any, programType: string) => {
    return {
      ...optionsByType,
      [programType]: programsByType[programType].map((program: ICareProgram) => {
        return {
          label: intl.messages[`${program.name}_short`],
          value: program.cpid
        };
      })
    };
  }, {});
};

export const formatCarePrograms = (
  patientInfo: IMonitorDataPatient | ITaskPatientInfo | IPatient,
  shorten: boolean, // passing this as true will return the short name such as RPM, RTM and CCM
  filterType?: ICareProgramType
) => {
  const { intl, groups } = store.getState();
  const groupPrograms =
    groups.carePrograms.find(
      (groupCarePrograms: IGroupCarePrograms) =>
        groupCarePrograms.gid ===
        // todo: fix on ms to return proper casing
        (patientInfo?.subgroup_gid || patientInfo?.subgroupGid || patientInfo?.gid)
    )?.programs || [];

  const patientCarePrograms = patientInfo?.patientCareProgram || [];
  const filteredPrograms = groupPrograms.filter((program: ICareProgram) =>
    patientCarePrograms.includes(program.cpid)
  );
  const formattedCarePrograms = filteredPrograms
    .filter((program: ICareProgram) => !filterType || program.type === filterType)
    .map((program: ICareProgram) => {
      if (shorten) {
        return intl.messages[`${program.name}_short`];
      } else return intl.messages[program.name];
    })
    .join(', ');
  return formattedCarePrograms;
};

export const isPatientCCMOnly = (patientCarePrograms: ICareProgram[]) => {
  const ccmCpid = 'a79d88ee-6094-4d0e-a678-0a616edf4188';
  return patientCarePrograms.length === 1 && patientCarePrograms[0].cpid === ccmCpid;
};
